import { WatchlistAddPortfolioLoanTable } from '../../tables/WatchlistAddPortfolioLoanTable';

export const onRenderWatchlistAddPortfolioGrid = (e, addLoanPropertyToWatchlist) => {
    if (!e.data.portfolio || e.data.portfolio.length == 1) {
        return null;
    }
    return (
        <div style={{ padding: '5px 20px' }}>
            <WatchlistAddPortfolioLoanTable
                properties={e.data.portfolio}
                onAddProperty={addLoanPropertyToWatchlist}
            />
        </div>
    );
};
